module.exports = __webpack_public_path__ + "static/jetpack-header@2x-b0de1649e5e9c080cc1583808e2ccc54.png";